const getters = {
  tit: state => state.app.tit,
}
export default getters
